import React from 'react';
import { isEmpty } from 'lodash';
import { truncate } from 'Components/utils/string/string.util';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { ContentSlideShow } from 'Components/frameworks/content-slideshow/ContentSlideShow';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Image } from 'Components/frameworks/image/Image';
export type ReviewProps = {
  authors?: Array<string>;
  date?: string;
  datetime?: string;
  rating?: number;
  ratingImageUrl?: string;
  text: string;
  title: string;
  url: string;
};
type Props = {
  className?: string;
  maxLengthOfReview?: number;
  reviews: Array<ReviewProps>;
};
export const TripAdvisorReviews = ({ className, maxLengthOfReview = 255, reviews = [] }: Props) => {
  const track = useTracking();

  if (isEmpty(reviews)) {
    return null;
  }

  return (
    <section className={className}>
      <ContentSlideShow>
        {reviews.map(
          ({ datetime, rating, ratingImageUrl, authors = [], date, text, title, url }) => {
            if (isEmpty(text)) {
              return null;
            }

            return (
              <DynamicLink
                className="block text-inherit"
                key={url}
                onClick={() =>
                  track({
                    actionGA: 'practicalInfos',
                    categoryGA: 'resort',
                    labelGA: 'tripAdvisorReviews',
                  })
                }
                target="_blank"
                url={url}
              >
                <blockquote cite={url} className="m-0">
                  {title && (
                    <p className="mb-10 font-bold" title={title}>
                      {title}
                    </p>
                  )}
                  <div className="mb-10 flex items-center gap-15">
                    <Image altMsg={`${rating}`} dontChangeAnything imageUrl={ratingImageUrl} />
                    <time dateTime={datetime} className="text-12">
                      {date}
                    </time>
                  </div>
                  {text && (
                    <p
                      className="mb-10 before:font-sans before:content-['“'] after:font-sans after:content-['”']"
                      title={text}
                    >
                      {truncate(text, maxLengthOfReview)}
                    </p>
                  )}
                  <small className="block text-12">
                    <span>
                      {authors.map((author) => {
                        return (
                          <span key={author} data-testid="TripAdvisorReviewsAuthor">
                            {author}
                            <br />
                          </span>
                        );
                      })}
                    </span>
                  </small>
                </blockquote>
              </DynamicLink>
            );
          },
        )}
      </ContentSlideShow>
    </section>
  );
};
